<template>
  <div class="otherbox">
    <Car ref='Car' :info="CarInfo" @resh='getCarOrHouseList()'></Car>
    <div class="htit htit1" style="margin:0;">
      <div class="h2">案涉标的物信息</div>
      <div class="rt" v-if='$common.AccAUTH(debInfo.accuser_id,"case:debtorCar:add")'>
        <a-button type="primary" ghost icon="plus" @click='CarInfo={};visibleShow("Car")'>添加</a-button>
      </div>
    </div>
    <div style="width:100%;overflow:hidden;">
      <div class="insetbox" v-if='carlist.length>0'>
        <div class="cselect" style="padding: 20px 20px 20px;">
          <a-radio-group button-style="solid" v-model='carOrHouse' @change="getCarOrHouseList">
            <a-radio :value="1">车辆信息</a-radio>
            <a-radio :value="2" disabled>房产信息</a-radio>
          </a-radio-group>
        </div>
        <div class="ntable table">
          <table cellpadding="0" cellspacing="0">
            <thead v-if="carOrHouse===1">
              <td width='40'>序号</td>
              <td width='280'>车辆品牌</td>
              <td width='70'>车辆颜色</td>
              <td width='50'>排量L</td>
              <td width='50'>排放</td>
              <td width='140'>车架号</td>
              <td width='80'>车辆登记人</td>
              <td width='90'>车牌号码</td>
              <td width='100'>初登日期</td>
              <td width='90'>车辆估值</td>
              <td width='90'>估值时间</td>
              <td width='144'>操作</td>
            </thead>
            <tbody v-if="carOrHouse===1">
              <tr v-for='(j,ind) in carlist' :key='j.id'>
                <td>{{ind+1}}</td>
                <td>
                  <Normap :tit="j.car?j.car.name: ''"></Normap>
                </td>
                <td>
                  <Normap :tit="j.color"></Normap>
                </td>
                <td>
                  <Normap :tit="j.car?j.car.displacement: ''"></Normap>
                </td>
                <td>
                  <Normap :tit="j.car?j.car.environmentalstandards:''"></Normap>
                </td>
                <td>
                  <Normap :tit="j.car?j.car.vin: ''"></Normap>
                </td>
                <td>
                  <Normap :tit="j.registrant"></Normap>
                </td>
                <td>
                  <Normap :tit="j.number"></Normap>
                </td>
                <td>
                  <Normap :tit="j.registration_time | yearFormats"></Normap>
                </td>
                <td>
                  <Normap :tit="j.valuation"></Normap>
                </td>
                <td>
                  <Normap :tit="j.valuation_time  | yearFormats"></Normap>
                </td>
                <td>
                  <a href='javascript:void(0);' @click='liteCar(j,true)' v-if='$common.AccAUTH(debInfo.accuser_id,"case:debtorCar:index")'>查看</a>
                  <a href='javascript:void(0);' @click='liteCar(j,false)' v-if='$common.AccAUTH(debInfo.accuser_id,"case:debtorCar:edit")'><span class="line"></span>修改</a>
                  <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delCar(j.id)' v-if='$common.AccAUTH(debInfo.accuser_id,"case:debtorCar:delete")'>
                    <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
                  </a-popconfirm>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="solids" style="margin-top:20px;" v-if='carlist.length>0'></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters} from 'vuex';
  import { getCarList,DelCar } from '@/server/car.js'
  import Car from './Car'
  export default {
    components: {
      Car
    },
    name: 'CarList',
    data() {
      return {
        carOrHouse: 1,
        CarInfo: {},
        carlist: [],
      }
    },
    computed: {
      ...mapGetters([
        'debInfo',
      ])
    },
    mounted() {
      this.getCarOrHouseList()
    },
    methods: {
      
      async getCarOrHouseList() {
        if (this.carOrHouse === 1) {
          const res = await getCarList({
            debtor_id: this.$route.params.id
          })
          this.carlist = res.list
        }
      },
      async delCar(id) {
        await DelCar({ id })
        this.$message.success({ content: '删除成功', key: 'updatable' });
        this.getCarOrHouseList()
      },
      liteCar(j, bool) {
        let k = Object.assign({ see: bool }, j)
        this.CarInfo = k
        this.visibleShow("Car")
      },
      visibleShow(name) {
        this.$store.dispatch("openkey", {
          key: name,
          by: true
        })
      },
    }
  }
</script>